(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wth-payment-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wth-payment-checkout')) {
    class WthPaymentCheckout extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => this.startCheckout(event));
      }

      async startCheckout(event) {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled || this.dataset.busy === 'true') return;

        const form = this.closest('form');
        const productForm = this.closest('product-form-component');
        const addButton = productForm?.querySelector('add-to-cart-component button');
        if (!form || addButton?.disabled || !form.reportValidity()) return;

        const formData = new FormData(form);
        if (!formData.get('id')) return;

        const title = this.querySelector('[data-wth-checkout-title]');
        const error = this.querySelector('.wth-payment-checkout__error');
        this.originalTitle = title.textContent;
        error.hidden = true;
        error.textContent = '';
        button.disabled = true;
        this.dataset.busy = 'true';
        this.setAttribute('aria-busy', 'true');
        title.textContent = this.dataset.loadingText;

        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || this.dataset.errorText);
          }
          window.location.assign(this.dataset.checkoutUrl);
        } catch (failure) {
          error.textContent = failure instanceof Error && failure.message
            ? failure.message
            : this.dataset.errorText;
          error.hidden = false;
          this.restoreButton();
        }
      }

      restoreButton() {
        if (this.dataset.busy !== 'true') return;
        this.querySelector('button').disabled = false;
        this.querySelector('[data-wth-checkout-title]').textContent = this.originalTitle;
        delete this.dataset.busy;
        this.removeAttribute('aria-busy');
      }
    }
    customElements.define('wth-payment-checkout', WthPaymentCheckout);
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('wth-payment-checkout').forEach((checkout) => checkout.restoreButton());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
